module.exports = __webpack_public_path__ + "img/erin-patterson1.b7d3bc26.png";